import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function resetRefundOrderSummary(): RootActionTypes {
  return standardAction(ActionTypes.RESET_REFUND_ORDER_SUMMARY);
}
